import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=5c73ca68&lang=scss&scoped=true"

import exportComponent from "/home/kain/brighten-legacy/brightenflower2024-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c73ca68"]])

export default __exports__